import { ref } from 'vue'
import { maintenanceMode } from '../utils/maintenance.js'

const isOpen = ref(false)
const preselectedPlanId = ref(null)
// Em manutenção, todo CTA de cadastro e o link "Entrar" abrem este aviso
// (MaintenanceNotice) em vez do formulário ou do login.
const isMaintenanceNoticeOpen = ref(false)

export function useSignupModal() {
  const openMaintenanceNotice = () => { isMaintenanceNoticeOpen.value = true }
  const closeMaintenanceNotice = () => { isMaintenanceNoticeOpen.value = false }

  const openSignupModal = (planId = null) => {
    if (maintenanceMode) {
      openMaintenanceNotice()
      return
    }
    preselectedPlanId.value = planId
    isOpen.value = true
  }
  const closeSignupModal = () => { isOpen.value = false }

  // Clique no "Entrar": em manutenção o app está fora do ar, então segura a
  // navegação (inclusive ctrl/cmd+clique) e mostra o aviso.
  const handleLoginClick = (event) => {
    if (!maintenanceMode) return
    event.preventDefault()
    openMaintenanceNotice()
  }

  return {
    isOpen,
    preselectedPlanId,
    openSignupModal,
    closeSignupModal,
    isMaintenanceNoticeOpen,
    openMaintenanceNotice,
    closeMaintenanceNotice,
    handleLoginClick,
  }
}
